import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { FullLayoutComponent } from "./layouts/full/full-layout.component";
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";

import { Full_ROUTES } from "./shared/routes/full-layout.routes";
import { CONTENT_ROUTES } from "./shared/routes/content-layout.routes";
import { AUTH_ROUTES } from "./shared/routes/auth-layout.routes";

import { AuthGuard } from './shared/auth/auth-guard.service';
import { NoAuthGuard } from './shared/auth/noauth-guard.service';

import { InitialDataResolver } from './shared/resolvers/app.resolver';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  { 
    path: '', 
    component: FullLayoutComponent, 
    data: { title: 'full Views' },
    children: Full_ROUTES,
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
    resolve: {
      initialData: InitialDataResolver
    }
  },
  { path: '', component: ContentLayoutComponent, data: { title: 'Auth Views' }, children: AUTH_ROUTES,canActivate: [NoAuthGuard] },
  { path: '', component: ContentLayoutComponent, data: { title: 'content Views' }, children: CONTENT_ROUTES },
  // 404 catch all
  {
    path: '**',
    redirectTo: 'pages/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true, preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
